import * as Sentry from "@sentry/nextjs";
import { SENTRY_DSN } from "./constants/sentry";
import { TRACKING_NAVIGATION_ABORT } from "./constants/tracking";

Sentry.init({
  dsn: SENTRY_DSN,

  // Performance Monitoring
  tracesSampleRate: 1.0,

  // Session Replay
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,

  // Intentional route-change abort from hooks/useFullPageLoadFor.js
  ignoreErrors: [TRACKING_NAVIGATION_ABORT],

  // Filter out console breadcrumbs
  beforeBreadcrumb(breadcrumb) {
    if (breadcrumb.category === 'console') {
      return null;
    }
    return breadcrumb;
  },

  // Integrations
  integrations: [
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  // Environment configuration
  environment: process.env.NODE_ENV,
  debug: process.env.NODE_ENV === "development",
});
